import React from "react";
import StyledReportEvent from "../ReportEvent/StyledReportEvent";
import { ReactComponent as Phone } from "../../../assets/icons/phone.svg";
import { ReactComponent as Email } from "../../../assets/icons/email.svg";
import Footer from "../../common/Footer/Footer";
import { useHistory } from "react-router-dom";
import { App } from "../../../routes/Constants";
import infoConstants from "../../../shared/infoConstants";
import APIVariables from "../../../services/api-variables";
import axios from "axios";
import { useEffect, useState } from "react";
import { handleCatch } from "../../../shared/helpers";
import LocalStorage from "../../../shared/localStorage";

const ContactUs = () => {
  const history = useHistory();

  const redirect = (URL) => {
    history.push(URL);
  };
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const [contactUs, setContactUs] = useState([]);

  const getContactUsDetails = async () => {
    const res = await axios
      .get(process.env.REACT_APP_BASE_URL + APIVariables.CONTACT_US, {
        headers: {
          Authorization: parseLocalStorage?.token,
        },
      })
      .catch((error) => {
        handleCatch(error);
      });

    if (res?.status === 200) {
      setContactUs(res.data);
    }
  };

  useEffect(() => {
    getContactUsDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <StyledReportEvent>
      <div className="layout">
        <div className="font-size-30 bold aqua-deep">Contact Us</div>
        <div className="mt-5 mb-2">
          <div
            className="font-size-18 aqua-deep bold"
            style={{ marginTop: "80px" }}
          >
            Risk Management:
          </div>
          <div className="font-size-16 mt-1 justify">
            For information and questions on the Risk Management of
            Lenalidomide, the Pregnancy Prevention Programme, please contact the
            relevant Marketing Authorisation Holder, please see contact details
            below:
          </div>
        </div>

        <div className="mt-5 mb-2">
          <div>
            <div>
              <div className="wrapper-contact mt-3">
                {contactUs.map((contact, index) => (
                  <div
                    key={index + 1}
                    className={`${
                      (index + 1) % 2 === 0
                        ? "contact-us-card-even"
                        : "contact-us-card-odd"
                    }`}
                  >
                    <div>
                      <div className="font-size-18 aqua-deep bold">
                        {contact.name}:
                      </div>
                      <p>Risk Management:</p>
                      <Phone />{" "}
                      <span className="font-size-16 bold">
                        Tel:{" "}
                        <a
                          className="font-size-16 bold"
                          href={`tel:${contact.risk_management_phone_number}`}
                        >
                          {contact.risk_management_phone_number}
                        </a>
                      </span>
                    </div>
                    <div>
                      <Email />{" "}
                      <span className="font-size-16 bold">
                        Email:{" "}
                        <a
                          className="font-size-16 bold"
                          href={`mailto:${contact.risk_management_email}`}
                        >
                          {contact.risk_management_email}
                        </a>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="mt-5 mb-2">
            <hr />
            <div className="font-size-18 aqua-deep bold">
              Data Protection Contact Details:
            </div>
            <div className="font-size-16 mt-1 justify">
              Please see below contact details for data protection queries for
              the relevant Marketing Authorisation Holder.
            </div>
          </div>
          <div>
            <div>
              <div className="wrapper-contact mt-3">
                {contactUs.map((contact, index) => (
                  <div
                    key={index + 1}
                    className={`${
                      (index + 1) % 2 === 0
                        ? "contact-us-card-even"
                        : "contact-us-card-odd"
                    }`}
                  >
                    <div>
                      <div className="font-size-18 aqua-deep bold">
                        {contact.name}:
                      </div>
                      {!!contact.data_protection_phone_number && (
                        <>
                          <Phone />{" "}
                          <span className="font-size-16 bold">
                            Tel:{" "}
                            <a
                              className="font-size-16 bold"
                              href={`tel:${contact.data_protection_phone_number}`}
                            >
                              {contact.data_protection_phone_number}
                            </a>
                          </span>
                        </>
                      )}
                    </div>
                    <div>
                      <Email />{" "}
                      <span className="font-size-16 bold">
                        Email:{" "}
                        <a
                          className="font-size-16 bold"
                          href={`mailto:${contact.data_protection_email}`}
                        >
                          {contact.data_protection_email}
                        </a>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="mt-5 mb-2">
            <hr />
            <div className="font-size-18 aqua-deep bold">
              Medical Information:
            </div>
          </div>
          <div>
            <div>
              <div className="wrapper-contact mt-3">
                {contactUs.map((contact, index) => (
                  <div
                    key={index + 1}
                    className={`${
                      (index + 1) % 2 === 0
                        ? "contact-us-card-even"
                        : "contact-us-card-odd"
                    }`}
                  >
                    <div>
                      <div className="font-size-18 aqua-deep bold">
                        {contact.name}:
                      </div>
                      <p>For Medical Information:</p>
                      <Phone />{" "}
                      <span className="font-size-16 bold">
                        Tel:{" "}
                        <a
                          className="font-size-16 bold"
                          href={`tel:${contact.medical_info_phone_number}`}
                        >
                          {contact.medical_info_phone_number}
                        </a>
                      </span>
                    </div>
                    <div>
                      <Email />{" "}
                      <span className="font-size-16 bold">
                        Email:{" "}
                        <a
                          className="font-size-16 bold"
                          href={`mailto:${contact.medical_info_email}`}
                        >
                          {contact.medical_info_email}
                        </a>
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5 mb-2">
          <div className="wrapper-tehnical-issues mt-3">
            <div>
              <div className="font-size-18 aqua-deep bold">
                For Technical Issues:
              </div>
              <p>
                To request assistance with any technical issues on the
                patientsafetyhub.ie, please contact:
              </p>
              <Phone />{" "}
              <span className="font-size-16 bold">
                Tel:{" "}
                <a className="font-size-16 bold" href="tel:+353 58 38 234">
                  +353 58 38 234
                </a>
              </span>
            </div>
            <div>
              <Email />{" "}
              <span className="font-size-16 bold">
                Email:{" "}
                <a
                  className="font-size-16 bold"
                  href={`mailto: ${infoConstants.patientSafetyHubEmail}`}
                >
                  {infoConstants.patientSafetyHubEmail}
                </a>
              </span>
            </div>
            <p
              className="font-size-16 bold mt-2"
              style={{ marginLeft: "35px" }}
            >
              Mon - Fri 09:00 - 17:00
            </p>
          </div>
          <div className="mt-5 mb-2">
            <div className="font-size-18 aqua-deep bold">
              Medical Information and reporting Adverse Events and Pregnancies:
            </div>
            <div className="font-size-16 mt-1 justify">
              Adverse Events (and cases of suspected or confirmed pregnancy or
              foetal exposure) should be reported. Adverse Event Report forms
              and Pregnancy Reporting forms can be found by following the link
              below.
            </div>
          </div>
          <div className="mt-5 mb-2">
            <button
              className="primary-button"
              onClick={() => redirect(App.REPORT_EVENT)}
            >
              Click here to access Adverse Event/Pregnancy report forms
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </StyledReportEvent>
  );
};

export default ContactUs;
